import SideMenuExpert from '../../Expert/SideMenuExpert/SideMenuExpert';
import SideMenuUser from '../../User/SideMenuUser/SideMenuUser';
import { useLocation } from 'react-router-dom';
import React, { useContext } from 'react';
import { ClientContext, ProfileContext } from '../../Contexts/contexts';
import CurrentPath from './CurrentPath';

function SideMenu() {
	const profileContext = useContext(ProfileContext);
	const clientContext = useContext(ClientContext);

	// Permet de recuperer la current location
	let location = useLocation();

	if (profileContext.isClient) {
		return (
			<div className="side-menu-main-container">
				{location.pathname !== '/' && (
					<div className="side-menu-path-container">
						<CurrentPath path={location.pathname} />
					</div>
				)}

				<div className="side-menu-component-container">
					<SideMenuUser
						path={location.pathname}
						clientExpertRelation={clientContext?.clientExpertRelation}
					/>
				</div>
			</div>
		);
	} else {
		return (
			<div className="side-menu-main-container">
				{location.pathname !== '/' && (
					<div className="side-menu-path-container">
						<CurrentPath path={location.pathname} />
					</div>
				)}

				<div className="side-menu-component-container">
					<SideMenuExpert path={location.pathname} />
				</div>
			</div>
		);
	}
}

export default SideMenu;
